if (document.querySelector('#top-nav')) {
  var app = new Vue({
    el: '#top-nav',
    data: {
      navOpen: false
    },
    methods: {
      toggleNav() {
        this.navOpen = !this.navOpen;
      }
    }
  });
}